import React from 'react';

const ModalComponent = ({ show, onClose, title, children }) => {
  return (
    <>
      {show && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h6 className="modal-title">{title || 'Quick Inquiry Form'}</h6>
                
                <a href="tel:+1800-040-956" className='position-relative modal-phone' style={{textDecorationLine:'none',fontSize:'12px'}}><i className="fas fa-phone me-2"></i>AUS: <span className='phone-number'>+1-800-040-956</span></a>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={onClose}
                ></button>
              </div>
              <div className="modal-body">
                {children || <p>This is a Bootstrap modal body</p>}
              </div>
              <div className="modal-footer p-0" style={{justifyContent:'flex-start'}}>
                <div className='row w-100 p-0'>
                    <div className='col-6 pt-2 text-bold text-primary'>
                        </div>
                    <div className='col-6 text-end'>
                    <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={onClose}
                >
                  Close
                </button>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ModalComponent;
